import * as React from "react";
import { Modal, Button } from "antd";
import "./index.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faSync } from "@fortawesome/free-solid-svg-icons";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { useContext, useEffect, useState } from 'react';
import { ServiceContext } from "src/services/provider/Service.provider";
import { ShowNotification } from "../ShowNotification/ShowNotification";
import { AnalysisModal } from "../AnalisysModal/AnalysisModal";
import { IBCheckModal } from "src/services/interfaces/Compliance/IBCheckModal";
import { BcheckTypeEnum } from 'src/services/interfaces/UserInterface';
import { TradePhaseEnum } from 'src/services/interfaces/trade/TradePhaseEnum';
import Tooltip from '../Tooltip/Tooltip';

interface IViewTradeBCheckButton {
  trade: ITrade;
}

export const ViewTradeBCheckButton: React.FC<IViewTradeBCheckButton> = ({
  trade
}) => {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [analysis, setAnalysis] = useState<IBCheckModal[]>(null);

  const { bCheckService, tradeService } = useContext(ServiceContext);

  const wfPhases = [TradePhaseEnum.Created, TradePhaseEnum.ContractInformation, TradePhaseEnum.LegalCertificates, TradePhaseEnum.DocumentValidation, TradePhaseEnum.DocumentApproval, TradePhaseEnum.SpecialProjectApproved, TradePhaseEnum.SpecialProjectValid, TradePhaseEnum.Diligence, TradePhaseEnum.Analysis, TradePhaseEnum.PreSpecialSituation];

  const isButtonDisabled = !wfPhases.includes(trade.phase);


  useEffect(() => {
    GetTradeBcheck();
  }, [trade]);

  function GetTradeBcheck() {
    setLoading(true);
    bCheckService
      .getBcheckByTradeId(trade.id)
      .then(resp => setAnalysis(resp))
      .catch(() => ShowNotification.Error("Tente novamente", "Falha ao buscar os bchecks do trade"))
      .finally(() => setLoading(false));
  }

  function reprocessCredit() {
    setLoading(true);
    const bcheckString: string = BcheckTypeEnum.Credit;

    tradeService.updateReLoadBackGroundCheck({
      tradeId: trade.id,
      bcheckType: bcheckString,
      changePhase: true
    })
      .catch(e => {
        ShowNotification.Error("Erro ao reprocessar.", "Por favor tente novamente mais tarde houve um erro ao enviar o BCheck.");
      })
      .finally(() => setLoading(false))

    setTimeout(() => {
      ShowNotification.Success("Sucesso", "Requisição enviada, aguarde alguns minutos para atualizarmos a base.");
    }, 500);
  }


  return (
    <>
      <button
        className="view-bcheck btn"
        onClick={() => setShowModal(true)}
      >
        <FontAwesomeIcon icon={faEye} />
        BCheck
      </button>
      <Modal
        className="modal-view-trade-bcheck"
        title="Bcheck"
        visible={showModal}
        footer={[
          <Tooltip key="sync-button" text={isButtonDisabled ? "Trade bloqueado para reprocessar devido a sua fase atual" : null}>
            <Button disabled={isButtonDisabled ? isButtonDisabled : isLoading} type="default" onClick={reprocessCredit} >
              <FontAwesomeIcon icon={faSync} style={{ marginRight: "5px" }} />
            Reprocessar Credito
            </Button>
          </Tooltip>,
          <Button key="ok-button" type="primary" onClick={() => setShowModal(false)}>Ok</Button>
        ]}
        onCancel={() => setShowModal(false)}
      >

        <AnalysisModal
          analysis={analysis}
          isLoading={isLoading}
        />

      </Modal>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/BcheckView/ViewTradeBCheckButton.tsx